import React from 'react';

import { useRouter, Redirect } from 'react-resource-router';

const RespositoryRedirect = () => {
  const [{ match, location }] = useRouter();
  const srcUrl = match.url.endsWith('/')
    ? `${match.url}src`
    : `${match.url}/src`;
  return <Redirect to={`${srcUrl}${location.search}`} />;
};

export default RespositoryRedirect;
